// import './App.css';
import Home from './pages/home';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import './assets/css/universal.css';
import './assets/css/styles.css';
import ScrollToTop from './assets/jss/scrollTop';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Portal imports
import Login from './pages/portal/Login';
import NavBar from './pages/portal/navBar';
import Dashboard from './pages/portal/dashboard';
import Nav from './pages/portal/home';
import ContactUs from './pages/contactUs';
import AboutUs from './pages/aboutUs';
import Careers from './pages/careers';
import { setLoader } from './pages/components/loader';
import Users from './pages/portal/user';
// import AddUser from './pages/portal/addUser';
// import Dashboard from './pages/portal/dashboard';
// import Users from './pages/portal/user';
// import Nav from './pages/portal/home';
import CreateUser from './pages/portal/newUser';
import AddStoreItem from './pages/portal/addStoreItem';
import UpdateStoreItem from './pages/portal/updateStoreItem';
// import NewOrder from './pages/portal/newOrder';
// import { setLoader } from './components/loader';
import EditUser from './pages/portal/editUser';
import StoreItems from './pages/portal/storeItems';
import ViewStoreItem from './pages/portal/veiwStoreItem';
import NewOrder from './pages/portal/newOrder';
import Register from './pages/portal/register';
import Events from './pages/portal/events';
import Highlights from './pages/portal/highlights';
import Gallery from './pages/portal/gallery';
import AddSlide from './pages/portal/addSlide';
import Sliders from './pages/portal/sliders';
import CreateEvent from './pages/portal/createEvent';
import { getSlides } from './api/api';
import NewGalleryImage from './pages/portal/addGallery';
import NewHighlight from './pages/portal/addHighlight';
import Units from './pages/portal/units';
import NewUnit from './pages/portal/addUnit';
import AllMembers from './pages/components/allMembers';
import Constitution from './pages/portal/handbook';
import UPdateAbout from './pages/portal/updateAbout';
import UserProfile from './pages/portal/userProfile';
import Messages from './pages/portal/messages';
import ChangePassword from './pages/portal/changePassword';
import Vote from './pages/portal/vote';
import NewIDs from './pages/portal/newUserID';
import Giveaway from './pages/portal/giveaway';
import GiveawayList from './pages/portal/giveawayList';
import VoteConfig from './pages/portal/voteConfig';

function App() {
  // const dispatch = useDispatch();
  // const sliders = useSelector((state) => state.sliders.sliders);
  // const events = useSelector(state => state.events.payload);
  

  
// useEffect(() => {
  setLoader();
// }, [])
useEffect(() => {
    // sliders.length === 0 && getSlides();

},[])
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Routes
      // onUpdate={() => window.scrollTo(0, 0)}
      >

        {/* <Route path='/' element={<Home  sliders={sliders} />} /> */}
        {/* <Route path='contact' element={<ContactUs />} /> */}
        {/* <Route path='about' element={<AboutUs />} /> */}
        <Route path='/giveawaylist' element={<GiveawayList />} />
        <Route path='/giveaway' element={<Giveaway />} />
        <Route path='/' element={<Login />} />
        <Route path='login' element={<Login />} />
        <Route path='register' element={<Register />} />
        <Route element={<Nav/>} >
            <Route path='dashboard' element={<Dashboard />} />
            <Route path='*' element={<div className='pt-4'> <h3 className=''> PAGE NOT FOUND </h3></div>}  />
            <Route path='/users' element={<Users/>} />
            <Route path='/new_user' element={<CreateUser/>}/>
            <Route path='/new_user_id' element={<NewIDs/>}/>
            {/* <Route path='/all_user' element={<AllMembers/>}/> */}
            <Route path='/user_details' element={<EditUser/>}/>
            <Route path='/vote' element={<Vote />} />
            <Route path='/vote_Config' element={<VoteConfig />} />
            {/* <Route path='/new_unit' element={<NewUnit />} />
            <Route path='/units' element={<Units />} />
            <Route path='/create_event' element={<CreateEvent />} />
            <Route path='/events' element={<Events />} /> 
            <Route path='/new_highlight' element={<NewHighlight />} />
            <Route path='/highlights' element={<Highlights />} />
            <Route path='/gallery' element={<Gallery />} />
            <Route path='/new_gallery_image' element={<NewGalleryImage />} />
            <Route path='/addSlide' element={<AddSlide />} />
            <Route path='/sliders' element={<Sliders />} /> */}
            <Route path='/handbook' element={<Constitution />}/> 
            <Route path='/update_about' element={<UPdateAbout />} />
            <Route path='/profile' element={<UserProfile />} />
            <Route path='/messages' element={<Messages />} />
            <Route path='/change_password' element={<ChangePassword />} />
        </Route> 

      </Routes>
    </BrowserRouter>
  );
}

export default App;
